import {Injectable} from "@angular/core";
import {IsPriceHiddenUseCase} from "@app/core/delivery-point/application/is-price-hidden.use-case";
import {GetSimilarProductsUseCase} from "@app/core/product/application/get-similar-products.use-case";
import {Product} from "@app/core/product/domain/dtos/product";
import {GetPromotionDetailUseCase} from "@app/core/promotion/application/get-promotion-detail.use-case";
import {PromotionDetail} from "@app/core/promotion/domain/dtos/promotion-detail";
import {IsLoggedInUseCase} from "@app/core/user/application/isLoggedIn.use-case";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {combineLatest, Observable, Subscriber} from "rxjs";
import {map, take, tap} from "rxjs/operators";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {SeoService} from "@app/presentation/services/seo/seo.service";
import {AlternateRoutes,} from "@app/presentation/services/alternate-routes";
import {TrackViewPromotionUseCase} from "@app/core/tracking/application/track-view-promotion.use-case";

@Injectable({
    providedIn: 'root',
})

export class PromotionDetailViewModel {

    isLoggedIn$ = this.isLoggedInUseCase.execute();
    isPriceHidden$ = this.isPriceHiddenUseCase.execute();

    canDisplayPrices$ = combineLatest([this.isLoggedIn$, this.isPriceHidden$]).pipe(
        map(([isLoggedIn, isPriceHidden]) => isLoggedIn && !isPriceHidden)
    );

    public notifier = new PopupNotifier();
    private getPromotionDetailSucceedEmitter!: Subscriber<PromotionDetail>;
    public getPromotionDetailSucceed$: Observable<PromotionDetail> = new Observable<PromotionDetail>(emitter => this.getPromotionDetailSucceedEmitter = emitter)
    constructor(
        private isLoggedInUseCase: IsLoggedInUseCase,
        private isPriceHiddenUseCase: IsPriceHiddenUseCase,
        private getPromotionDetailUseCase: GetPromotionDetailUseCase,
        private getSimilarProductsUseCase: GetSimilarProductsUseCase,
        private seoService: SeoService,
        private alternateRoutes: AlternateRoutes,
        private trackViewPromotionUseCase: TrackViewPromotionUseCase,
    ) { }

    getPromotionDetail(promotionCode: string): void {
        this.getPromotionDetailUseCase.execute(promotionCode)
            .pipe(
                take(1),
                tap(promotion => this.seoService.setMetadata({
                    title: promotion.name,
                    image: promotion.image,
                    description: promotion.description,
                    alternatesUrls: this.alternateRoutes.promotionDetail({promotion: promotion})
                })),
                tap(promotion => this.trackViewPromotion(promotion))
            )
            .subscribe({
                next: promotionDetail => this.getPromotionDetailSucceedEmitter.next(promotionDetail),
                error: error => this.notifier.notifyError(error)
            });
    }

    private trackViewPromotion(promotion: PromotionDetail) {
        this.trackViewPromotionUseCase.execute({
            promotionId: promotion.code,
            promotionName: promotion.name,
            items: promotion.details.map(product => ({itemId: product.code, itemName: product.name})),
        })
    }

    getSimilarProducts(productCode: string, itemsPerPage: number, page: number): Observable<Product[]> {
        return this.getSimilarProductsUseCase.execute(productCode, itemsPerPage, page).pipe(
            take(1),
            onError(error => this.notifier.notifyError(error))
        );
    }
}
